/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPcLaptopIcon16Light } from './TechPcLaptopIcon16Light';
import { TechPcLaptopIcon16Regular } from './TechPcLaptopIcon16Regular';
import { TechPcLaptopIcon16Solid } from './TechPcLaptopIcon16Solid';
import { TechPcLaptopIcon20Light } from './TechPcLaptopIcon20Light';
import { TechPcLaptopIcon20Regular } from './TechPcLaptopIcon20Regular';
import { TechPcLaptopIcon20Solid } from './TechPcLaptopIcon20Solid';
import { TechPcLaptopIcon24Regular } from './TechPcLaptopIcon24Regular';
import { TechPcLaptopIcon24Solid } from './TechPcLaptopIcon24Solid';
import { TechPcLaptopIcon32Regular } from './TechPcLaptopIcon32Regular';
import { TechPcLaptopIcon64Regular } from './TechPcLaptopIcon64Regular';
var sizes = {
    16: {
        light: TechPcLaptopIcon16Light,
        regular: TechPcLaptopIcon16Regular,
        solid: TechPcLaptopIcon16Solid,
    },
    20: {
        light: TechPcLaptopIcon20Light,
        regular: TechPcLaptopIcon20Regular,
        solid: TechPcLaptopIcon20Solid,
    },
    24: {
        regular: TechPcLaptopIcon24Regular,
        solid: TechPcLaptopIcon24Solid,
    },
    32: {
        regular: TechPcLaptopIcon32Regular,
    },
    64: {
        regular: TechPcLaptopIcon64Regular,
    },
};
export var TechPcLaptopIcon = forwardRef('TechPcLaptopIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
